import { render, staticRenderFns } from "./LibraryPeople.vue?vue&type=template&id=04aa0eb1&scoped=true&"
import script from "./LibraryPeople.vue?vue&type=script&lang=js&"
export * from "./LibraryPeople.vue?vue&type=script&lang=js&"
import style0 from "./LibraryPeople.vue?vue&type=style&index=0&id=04aa0eb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa0eb1",
  null
  
)

export default component.exports